<div class="flex flex-col bg-white p-2 rounded-md" *transloco="let t">
  @if (label()) {
    <mat-label
      class="text-sm font-semibold mb-1"
      [class.error-red]="!control()?.untouched && control()?.invalid"
      [class.opacity-50]="control()?.disabled"
    >
      {{ label() }}
      @if (isRequired) {
        <sup>*</sup>
      }
    </mat-label>
  }

  <mat-form-field appearance="outline">
    @let showSearchBox = options()?.length > selectSearchBoxThreshold;

    <mat-select
      [formControl]="control()"
      [multiple]="isMultiple()"
      [placeholder]="placeholder()"
      [compareWith]="compareWithFn"
      [disabled]="control().disabled"
      (selectionChange)="onSelectionChange()"
      (openedChange)="onOpen($event)"
      [panelClass]="['custom-multi-select', showSearchBox ? 'select-search-box' : '']"
    >
      @if (showSearchBox) {
        <mat-form-field class="w-full sticky top-[0px] bg-white z-10" appearance="outline">
          <input #searchbox matInput [placeholder]="t('search')" [(ngModel)]="searchText" />

          @if (searchText()) {
            <button type="button" mat-icon-button matSuffix (click)="resetSearch()">
              <mat-icon class="mat-icon-outlined mat-icon-18 size-[18px]">close</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if (noneOptionLabel()) {
        <mat-option>{{ noneOptionLabel() }}</mat-option>
      }

      @for (option of formattedOptions; track $index) {
        <mat-option [value]="option.value" [class.hidden]="option?.hidden">{{ option.label }}</mat-option>
      }
    </mat-select>

    @if (hint()) {
      <mat-hint align="start">
        <span class="text-xs palette-text-64">{{ hint() }}</span>
      </mat-hint>
    }

    @if (showError()) {
      <mat-error [validationControl]="control()"></mat-error>
    }
  </mat-form-field>
</div>
